// extracted by mini-css-extract-plugin
module.exports = {"footerStyle":"footerStyle--2mGAC"};